var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFacebook = function SvgIconFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.777 1.337c-3.364.11-6.194 2.83-6.427 6.188a6.66 6.66 0 0 0 5.654 7.06V9.767H5.928a.876.876 0 1 1 0-1.752h1.075V6.849c0-1.93.941-2.778 2.546-2.778q.356 0 .614.014c.424.02.752.374.752.798a.8.8 0 0 1-.8.8h-.294c-.682 0-.92.646-.92 1.374v.958h1.247c.394 0 .695.352.635.741l-.072.467a.64.64 0 0 1-.635.545H8.901V14.6c3.256-.442 5.766-3.224 5.766-6.599a6.667 6.667 0 0 0-6.89-6.663"
  })));
};
export default SvgIconFacebook;